// only include mobile, no tablet, in case we need mobile specific logic
const isMobile = (/* istanbul ignore next */ userAgent = window.navigator.userAgent, screenWidth = window.screen.width) => {
  if (screenWidth < 550 || /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|windows mobile|windows phone/i.test(userAgent)) {
    return true
  }
  return false
}
// this method also works on browser simulator, can be used to check if we need toggle touch to click
const isTouchDevice = (/* istanbul ignore next */ userAgent = window.navigator.userAgent) => {
  if (
    (!userAgent && /* istanbul ignore next */ window.matchMedia('(any-hover: none)').matches) ||
    /Android|webOS|iPhone|ipad|iPod|BlackBerry|IEMobile|Opera Mini|windows mobile|windows phone|tablet|HarmonyOS|mobi/i.test(userAgent)
  ) {
    return true
  }
  return false
}

export { isMobile, isTouchDevice }
